module.exports = __webpack_public_path__ + "media/scen.1721f255.mp4";